<template>
    <div id="searchMenuPanel">
        <div class="title">Search</div>

        <input id="search-input"
               type="text"
               class="input"
               ref="searchInput"
               placeholder="Search for..."
               @keypress.enter="handleSearch"
               @keydown.esc="handleClearSearch"
               v-model="term"
               autocomplete="false"
        />

        <div class="results-model" v-for="item in resultModelsWithItems" :key="item.key">
            <label class="label" v-if="searchResults[item.key]">{{item.title}}</label>
            <ul class="result-list">
                <template v-if="item.models && item.models.length">
                    <li class="result-list-item" v-for="model in item.models" :key="model.id">
                        <router-link :to="item.route(model)">
                            {{ model[item.labelKey] }}
                        </router-link>
                    </li>
                </template>
                <template v-else-if="searchResults[item.key] && searchResults[item.key].length === 0">
                    <li>No search results</li>
                </template>
            </ul>
            <p class="help" v-if="searchResults[item.key] && searchResults[item.key].length > limit">
                Plus {{ searchResults[item.key].length - limit }} additional results.
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">

import NotificationError from '@/use/NotificationError';

import {computed, onMounted, ref} from "vue";
import {useSystemStore} from "@/stores/SystemStore";

const systemStore = useSystemStore();
const limit = ref(10);
const searchInput = ref<HTMLElement | null>(null);
const term = ref('');
const resultModels = ref([
  {
    title: 'Projects',
    key: 'projects',
    labelKey: 'name',
    route: (model: any) => {
      return {
        name: 'projects/show',
        params: {
          projectId: model.id,
        },
      };
    },
  },
]);

onMounted(() => {
  if (searchInput.value) {
    searchInput.value.focus();
  }
});

const resultModelsWithItems = computed(() => {
  return resultModels.value.map(item => {
    const models = searchResults.value[item.key] || [];
    return {
      ...item,
      models: models.slice(0, limit.value),
    };
  });
})

const searchResults = computed(() => systemStore.searchResults || []);

function handleSearch() {
  systemStore.search({
    params: {
      q: term.value,
      include: [
        'projects',
      ],
    }
  }).then(() => {
  }).catch((error) => {
    if (error.errors) {
      NotificationError({}, error);
    }
    else {
      NotificationError({
        message: error,
      });
    }
  });
}

function handleClearSearch() {
  term.value = '';
}

</script>

<style scoped lang="scss">
  #searchMenuPanel{
    color: var(--nav-secondary-text);
  }

    #search-input {
        border-bottom-width: 2px;
        border-left: none;
        border-right: none;
        border-radius: 0;
        border-top: none;
        box-shadow: none;

        &:active {
            border-bottom-color: $primary;
        }
    }
    .title{
      color: var(--nav-secondary-text);
    }

    .results-model {
      margin: 20px 0;
      color: var(--nav-secondary-text);
      label{
        color: var(--nav-secondary-text);
      }

      .result-list {
        background: var(--nav-secondary-background);
        color: var(--nav-secondary-text);

        li {
          list-style-type: none;
        }

        .result-list-item {
          margin-top: 3px;
          margin-bottom: 3px;
          display: flex;
          align-items: center;
          color: var(--nav-secondary-text);
          padding: 0.5em 0.75em;

          &:hover {
            border-radius: 5px;
            background-color: var(--nav-secondary-background-hover);
          }

          a{
            color:var(--nav-secondary-text);
            width:100%;
            display:block;
          }

          span:nth-child(2) {
            vertical-align: top;
            margin-left: .3em;
          }
        }
      }

    }
</style>
